export enum ListingType {
  Residential = 'residential',
  Lots = 'lots',
  Lease = 'lease'
}
